import { FormControls } from '@elementary/common-ui/components';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesFreshnessAnomaliesCloudConfig = ({ watch }: Props) => (
  <>
    {!watch('anomalyConfig.fixedThreshold') && (
      <FormControls.FormText>
        Anomaly detection - automatically detect the SLA with a sensitivity
        level of <b>{watch('anomalyConfig.sensitivity')}</b>.
      </FormControls.FormText>
    )}

    {watch('anomalyConfig.fixedThreshold') && (
      <FormControls.FormText>
        <span>{`Static SLA - alert when table hasn't updated for `}</span>{' '}
        <b>
          {pluralizeString(
            watch('anomalyConfig.fixedThreshold.count') || 1,
            watch('anomalyConfig.fixedThreshold.period') || 'day',
            `${watch('anomalyConfig.fixedThreshold.period') || 'day'}s`,
          )}
        </b>
        .
      </FormControls.FormText>
    )}

    {watch('anomalyConfig.trainingPeriod') && (
      <FormControls.FormText>
        Training period:{' '}
        <b>
          {pluralizeString(
            watch('anomalyConfig.trainingPeriod.count') || 1,
            watch('anomalyConfig.trainingPeriod.period') || 'day',
            `${watch('anomalyConfig.trainingPeriod.period') || 'day'}s`,
          )}
        </b>
        .
      </FormControls.FormText>
    )}

    <SeverityRenderer severity={watch('severity')?.type || 'error'} />
  </>
);

export default TablesFreshnessAnomaliesCloudConfig;
